import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpJobs'

export const urlCheckerList           = params   => Http.get(`/admin/vacancy-url-checker${serialize(params)}`)
export const urlCheckerStats          = ()        => Http.get('/admin/vacancy-url-checker/stats')
export const urlCheckerCheckAll       = ()        => Http.post('/admin/vacancy-url-checker/check-all')
export const urlCheckerToggle         = id        => Http.patch(`/admin/vacancy-url-checker/${id}/toggle`)
export const urlCheckerOverride       = id        => Http.patch(`/admin/vacancy-url-checker/${id}/override`)
export const urlCheckerRecheck        = id        => Http.post(`/admin/vacancy-url-checker/${id}/recheck`)
export const urlCheckerGetSettings    = ()        => Http.get('/admin/vacancy-url-checker/settings')
export const urlCheckerUpdateSettings = payload   => Http.patch('/admin/vacancy-url-checker/settings', payload)
